import {
  B2bButton,
  B2bIcon,
  B2bScrollableContainer,
  B2bTable,
  B2bTableCell,
  B2bTableHeader,
  B2bTableRow, B2bTableRowgroup
} from "@otto-de/b2b-react-components";
import React from "react";

export default function WFFOTable({ data, displayJson }) {
  return (
      <div>
        <B2bScrollableContainer>
          <B2bTable>
            <B2bTableRowgroup type="header">
              <B2bTableRow highlight="false">
                <B2bTableHeader>WFFO ID</B2bTableHeader>
                <B2bTableHeader>Status</B2bTableHeader>
                <B2bTableHeader>Warehouse</B2bTableHeader>
                <B2bTableHeader>Delivery Date</B2bTableHeader>
                {data.latestTransferTime &&
                <B2bTableHeader>Latest Transfer Time</B2bTableHeader>}
                {data.carrierInformation &&
                    <B2bTableHeader>Carrier</B2bTableHeader> }
                <B2bTableHeader>Content</B2bTableHeader>
              </B2bTableRow>
            </B2bTableRowgroup>
            <B2bTableRowgroup type="body">
              <B2bTableRow highlight="false">
                <B2bTableCell data-testid="wffo_id">{data.wffoId}</B2bTableCell>
                <B2bTableCell data-testid="status">{data.status}</B2bTableCell>
                <B2bTableCell data-testid="warehouse">{data.warehouse}</B2bTableCell>
                <B2bTableCell data-testid="delivery_date">{data.deliveryDate}</B2bTableCell>
                {data.latestTransferTime &&
                    <B2bTableCell>{data.latestTransferTime}</B2bTableCell>}
                {data.carrierInformation &&
                <B2bTableCell>{data.carrierInformation.carrier}</B2bTableCell>}
                <B2bTableCell style={{textAlign: "center"}}>
                  <B2bButton variant="secondary" onClick={displayJson} data-testid="show_json_button">
                    <B2bIcon slot="start" icon="b2b_icon-code-management"
                             size="100"/>
                  </B2bButton>
                </B2bTableCell>
              </B2bTableRow>
            </B2bTableRowgroup>
          </B2bTable>
        </B2bScrollableContainer>
      </div>
  )
}